import { Dayjs } from 'dayjs';

export enum Gender {
  M = 'M',
  F = 'F',
  UNI = 'UNI',
  HIDE = 'HIDE',
}

export enum UserStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  BLOCKED = 'BLOCKED',
}

export type UserType = 'storestaff' | 'vendor' | 'admin';

export enum ERPUserType {
  vendor = 'vendor',
  internal = 'internal',
}

export interface IRole {
  id: number;
  name: string;
  permissions: Array<string>;
  portalCode: string;
}

export interface IAdminUserAttributes {
  vendorIds?: Array<number>;
  categoryIds?: Array<number>;
  warehouseIds?: Array<number>;
  salesChannelIds?: Array<number>;
}

export interface IERPUser {
  adminUserAttributes: IAdminUserAttributes;
  createdBy: string;
  createdOn: string;
  email?: string;
  id: number;
  isActive: boolean;
  lastLoginTime: string;
  lastModifiedOn: string;
  name?: string;
  profileImageUrl?: string;
  roles: Array<IRole>;
  storeSalesChannelIds?: number;
  userType: ERPUserType;
  vendorId?: number;
  version: number;
  password?: string;
  notificationRequested?: boolean;
  notificationSubmitted?: boolean;
  notificationRequestId?: string;
  notificationError?: string;
}

export interface IResetERPUserPasswordResponse {
  user: IERPUser;
  password: string;
  notificationRequested: boolean;
  notificationSubmitted: boolean;
  notificationRequestId?: string;
  notificationError?: string;
}

export interface ICustomer {
  createdOn: string;
  dob?: string;
  gender?: Gender;
  id: number;
  name?: string;
  country: string;
  phone: string;
  profileImageUrl?: string;
  publicProfileId?: string;
  referralCode: string;
  referredViaCode?: string;
  status: UserStatus;
  whatsappOptin: boolean;
}

export interface ICustomerFilterVariables {
  name: string;
  status: UserStatus;
  createdOn?: [Dayjs, Dayjs];
}

export interface IRole {
  id: number;
  name: string;
  permissions: Array<string>;
}

export enum B2BCustomerType {
  INFLUENCER = 'INFLUENCER',
}

export interface IB2BCustomerAddress {
  phone: string;
  addressLine: string;
  locality: string;
  landmark: string;
  pincode: string;
  cityCode: string;
  cityDisplayName: string;
  stateCode: string;
  stateDisplayName: string;
  countryCode: string;
  countryDisplayName: string;
  fullAddress: string;
  lat: number;
  lng: number;
}

export interface IB2BCustomer {
  id: number;
  name: string;
  type: B2BCustomerType;
  email: string;
  phone: string;
  gstin: string;
  billingAddress: IB2BCustomerAddress;
  shippingAddress: IB2BCustomerAddress;
}
